import { cn } from "@/lib/utils";
import { statisticsSidebarSurfaceCardClassName } from "../Statistics/components/statisticsShadcnCardShell";

/** Reports list / wizard cards — sidebar surface in dark mode (matches Statistics / Trade Log). */
export const reportsMainCardClassName = cn(
  "flex w-full min-w-0 flex-col gap-4 rounded-[6px] border border-border bg-card p-4 text-card-foreground shadow-none",
  statisticsSidebarSurfaceCardClassName,
);

export const reportsPendingCardClassName = cn(
  "w-full min-w-0 rounded-lg border border-solid border-[#38BBD1] p-4 font-[family-name:var(--font-primary)]",
  "bg-card",
  statisticsSidebarSurfaceCardClassName,
);

/** Individual report card in the type board lanes. */
export const reportsListCardClassName = cn(
  "flex w-full min-w-0 flex-col gap-0 overflow-hidden !rounded-[6px] border border-solid border-border bg-card p-0 text-card-foreground shadow-none !ring-0 transition-colors",
  "hover:border-[#38BBD1]/50",
  statisticsSidebarSurfaceCardClassName,
);
